import history from "constants/history";
import React from "react";

const NoCigar = () => {
  return (
    <div className="signInUpFormBox form-shadow">
      <div className={`my-modal-header business-text`}>
        Oops! Your invite link did not work
      </div>
      <br />
      It may be expired or simply incorrect.
      <br />
      <br />
      <button
        onClick={() => {
          history.push("/");
        }}
        className="confirm-button business-button"
      >
        Go to EfficeSpace Home
      </button>
    </div>
  );
};

export default NoCigar;
